






























































import { Component, Ref, Vue } from 'vue-property-decorator'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindCashbackUseCase, SaveCashbackUseCase } from '@/usecases'

@Component({
	components: {
		CampoDecimal,
		Confirmacao,
	},
})
export default class DialogoDeMetaDaAcaoDeCashback extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeValor!: Vue
	@Ref() confirmacaoRemocao!: Confirmacao

	findCashbackUseCase = new FindCashbackUseCase()
	saveCashbackUseCase = new SaveCashbackUseCase()

	mostra = false
	carregando = false
	salvando = false
	removendo = false
	possuiMeta = false
	acaoId = ''
	nomeDaAcao = ''
	valorMeta: number | null = null
	valorMetaSalva = 0
	valorAtingido = 0
	valorCashbackAfetado = 0
	valorCashbackGeradoEmDobro: number | null = null

	get metaFormatada() {
		return this.formatarMoeda(this.valorMeta || 0)
	}

	get totalDeCashbackDaAcao() {
		return this.valorCashbackAfetado + (this.valorCashbackGeradoEmDobro || 0)
	}

	get percentualAtingido() {
		if (!this.valorMeta) return 0
		return Math.round((this.valorAtingido / this.valorMeta) * 100)
	}

	formatarMoeda(valor: number) {
		return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
	}

	metaValida = (valor: number | null) =>
		(typeof valor === 'number' && valor > 0) || 'Informe um valor maior que zero'

	async mostrar(acaoId: string, nomeDaAcao: string) {
		this.acaoId = acaoId
		this.nomeDaAcao = nomeDaAcao
		this.valorMeta = null
		this.possuiMeta = false
		this.valorAtingido = 0
		this.valorCashbackAfetado = 0
		this.valorCashbackGeradoEmDobro = null
		this.mostra = true

		try {
			this.carregando = true
			const resumo = await this.findCashbackUseCase.findMetaDaAcaoDeCashback(acaoId)
			this.possuiMeta = resumo.valorMeta !== null
			this.valorMeta = resumo.valorMeta
			this.valorMetaSalva = resumo.valorMeta || 0
			this.valorAtingido = resumo.valorAtingido
			this.valorCashbackAfetado = resumo.valorCashbackAfetado
			this.valorCashbackGeradoEmDobro = resumo.valorCashbackGeradoEmDobro
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
			this.$nextTick(() => {
				this.form.resetValidation()
				const input = this.campoDeValor.$el.querySelector('input')
				if (input) input.focus()
			})
		}
	}

	esconder() {
		this.mostra = false
	}

	async salvar() {
		if (!this.form.validate() || this.valorMeta === null) return

		if (this.possuiMeta) {
			const confirmado = await this.confirmacaoRemocao.mostrarComParametros(
				'Atualizar meta?',
				`A meta da ação <strong>${this.nomeDaAcao}</strong> passará de <strong>${this.formatarMoeda(this.valorMetaSalva)}</strong> para <strong>${this.formatarMoeda(this.valorMeta)}</strong>. Deseja realmente continuar?`,
			)
			if (!confirmado) return
		}

		try {
			this.salvando = true
			await this.saveCashbackUseCase.definirMetaDaAcaoDeCashback(this.acaoId, this.valorMeta)
			AlertModule.setSuccess('Meta salva com sucesso')
			this.$emit('sucesso')
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	async remover() {
		const confirmado = await this.confirmacaoRemocao.mostrarComParametros(
			'Remover meta?',
			`A meta da ação <strong>${this.nomeDaAcao}</strong> será excluída. Deseja realmente continuar?`,
		)
		if (!confirmado) return

		try {
			this.removendo = true
			await this.saveCashbackUseCase.removerMetaDaAcaoDeCashback(this.acaoId)
			AlertModule.setSuccess('Meta removida com sucesso')
			this.$emit('sucesso')
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.removendo = false
		}
	}
}
